import { Injectable } from '@angular/core';
import { LoadingController } from "ionic-angular";


@Injectable()
export class LoadingProvider {
    constructor(
        public loadingCtrl: LoadingController) { }

    create() {
        let newLoading = this.loadingCtrl.create({
            spinner: 'dots',
            content: ``,
        });
        newLoading.present();
        return newLoading;
    }


}


// WEBPACK FOOTER //
// ./src/providers/loading.ts